/** Ability description text, ported from the prototype's GEMS desc lambdas. */
import { GEMS, SPECIALS, aquaCd, poisonDps, slowF } from '../data/balance.js';
import type { GemCell } from '../core/types.js';
import { el } from './dom.js';

export function descFor(cell: GemCell): string {
  if (cell.special !== undefined) return SPECIALS[cell.special].desc;
  const t = cell.tier;
  switch (cell.type) {
    case 'ruby':
      return `Cleave: ${30 + t * 10}% damage in ${(1.4 + t * 0.2).toFixed(1)} radius`;
    case 'sapphire':
      return `Slows target ${Math.round((1 - slowF(t)) * 100)}% for 3s`;
    case 'emerald':
      return `Poison: ${poisonDps(t)}/s for 5s (ignores armor)`;
    case 'diamond':
      return `${Math.round((0.2 + t * 0.04) * 100)}% chance to crit x2.5`;
    case 'amethyst':
      return `Fast attacks; shreds ${2 * (t + 1)} armor/hit (max ${8 * (t + 1)})`;
    case 'opal':
      return `Aura: nearby gems +${Math.round((0.15 + t * 0.09) * 100)}% attack speed`;
    case 'topaz':
      return 'Hits up to 3 targets';
    case 'aquamarine':
      return `Very fast attacks (${(1 / aquaCd(t)).toFixed(1)}/s)`;
  }
}

/** The little gem-shaped color swatch used in cards, tooltips, and recipes. */
export function swatchFor(cell: GemCell): HTMLSpanElement {
  if (cell.special !== undefined) {
    return el('span', {
      className: 'sw star',
      style: { background: SPECIALS[cell.special].color },
    });
  }
  const base = GEMS[cell.type];
  return el('span', { className: `sw ${base.shape}`, style: { background: base.color } });
}
